module.exports = __webpack_public_path__ + "img/RABOBANK.9be6ef03.jpg";